import PropTypes from 'prop-types';
import React from 'react';

function Hold(props) {
  const { fill } = props;
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.875 5.125H7.625C6.93464 5.125 6.375 5.68464 6.375 6.375V17.625C6.375 18.3154 6.93464 18.875 7.625 18.875H8.875C9.56536 18.875 10.125 18.3154 10.125 17.625V6.375C10.125 5.68464 9.56536 5.125 8.875 5.125Z"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M16.375 5.125H15.125C14.4346 5.125 13.875 5.68464 13.875 6.375V17.625C13.875 18.3154 14.4346 18.875 15.125 18.875H16.375C17.0654 18.875 17.625 18.3154 17.625 17.625V6.375C17.625 5.68464 17.0654 5.125 16.375 5.125Z"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
    </svg>
  );
}

Hold.propTypes = {
  fill: PropTypes.string.isRequired
};

export default Hold;
